var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2176 23.3714L25.5257 11.7866L24.3928 10.6641L15.5915 19.3848L11.5668 23.3714C11.3658 23.5716 11.2529 23.8426 11.2529 24.125C11.2529 24.4074 11.3658 24.6784 11.5668 24.8786L19.6076 32.8458L24.3928 37.5859L33.1929 28.8652L33.33 28.7306L37.2176 24.8846C37.3183 24.7855 37.3983 24.6676 37.4528 24.5378C37.5074 24.4079 37.5355 24.2687 37.5355 24.128C37.5355 23.9873 37.5074 23.8481 37.4528 23.7182C37.3983 23.5884 37.3183 23.4705 37.2176 23.3714ZM24.3928 28.1056L20.3754 24.125L24.3928 20.1444L28.4089 24.125L24.3928 28.1056Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3918 20.1452C23.1283 18.8936 22.4161 17.1974 22.4106 15.4272C22.4052 13.6569 23.107 11.9565 24.3627 10.6973L15.5723 19.4036L20.3562 24.1438L24.3918 20.1452Z",
    fill: "url(#paint0_linear_1371_63726)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4196 24.1133L24.3926 28.1047C25.6608 29.3617 26.3733 31.0663 26.3733 32.8437C26.3733 34.621 25.6608 36.3257 24.3926 37.5826L33.2073 28.8535L28.4196 24.1133Z",
    fill: "url(#paint1_linear_1371_63726)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1371_63726",
    x1: 23.6725,
    y1: 16.1177,
    x2: 18.1141,
    y2: 21.7263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1371_63726",
    x1: 25.1592,
    y1: 32.0841,
    x2: 30.7068,
    y2: 26.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.a4a1f729aeed5d105c173aed70d1422f.svg";
export { ForwardRef as ReactComponent };